import request from "@/utils/request";

// 购物车 API

/**
 * 分页显示购物车表
 * @param {*} params
 * @returns
 */
export function cartListApi(params: {
  page?: number;
  limit?: number;
  offset?: number;
}) {
  return request({
    url: "/front/cart/list",
    method: "GET",
    params,
  });
}

/**
 * 获取购物车数量
 * @param {*} params
 * @returns
 */
export function cartCountApi(
  params: { type: string; numType: boolean } = {
    type: "sum",
    numType: true,
  }
) {
  return request({
    url: "/front/cart/count",
    method: "GET",
    params,
  });
}

/**
 * 删除商品
 * @param {*} params
 * @returns
 */
export function cartDelApi(params: { ids: string }) {
  return request({
    url: "/front/cart/delete",
    method: "POST",
    params,
  });
}

/**
 * 修改商品数量
 * @param {*} params
 * @returns
 */
export function updateCartNumApi(params: { id: number; number: number }) {
  return request({
    url: "/front/cart/num",
    method: "POST",
    params,
  });
}

/**
 * 添加商品
 * @param {*} data
 * @returns
 */
export function cartSaveApi(data: {
  productId: number;
  productAttrUnique: string | number | undefined;
  cartNum: number;
}) {
  return request({
    url: "/front/cart/save",
    method: "POST",
    data,
  });
}

/**
 * 购物车重选提交
 * @param {*} data
 * @returns
 */
export function cartResetApi(data: {
  id: number;
  num: number;
  productId: number;
  unique: number;
}) {
  return request({
    url: "/front/cart/resetcart",
    method: "POST",
    data,
  });
}

/**
 * 预下单
 * @param {*} data
 * @returns
 */
export function createPreOrderApi(data: {
  preOrderType: string;
  orderDetails: {
    shoppingCartId?: number;
    productId?: number;
    attrValueId?: number;
    productNum?: number;
    orderNo?: string;
  }[];
}) {
  return request({
    url: "/front/order/pre/order",
    method: "POST",
    data,
  });
}

/**
 * 加载预下单
 * @param {*} params
 * @returns
 */
export function getPreOrderApi(params: { preOrderNo: string }) {
  return request({
    url: `/front/order/load/pre/${params.preOrderNo}`,
    method: "GET",
  });
}

/**
 * 创建订单
 * @param {*} data
 * @returns
 */
export function createOrderApi(data: {
  preOrderNo: string;
  addressId?: number;
  payType: string;
  payChannel: string;
  mark?: string;
  phone?: string;
  otpToken?: string;
  type?: string;
  voucherId?:number;
  language?: string;
}) {
  return request({
    url: "/front/order/create",
    method: "POST",
    data,
  });
}
